"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.templateFromKey = exports.formatTemplateMap = exports.isValidTemplateName = exports.ValidTemplateNames = exports.isTemplate = void 0;
const templates_1 = require("../lib/templates");
const Util_1 = require("./Util");
const isTemplate = (t) => !(0, Util_1.isNull)(t);
exports.isTemplate = isTemplate;
exports.ValidTemplateNames = [
    'template1',
    'template2',
    'template3' // broadwayHealthDemo
];
const isValidTemplateName = (templateName) => exports.ValidTemplateNames.includes(templateName);
exports.isValidTemplateName = isValidTemplateName;
exports.formatTemplateMap = {
    template1: templates_1.template1,
    template2: templates_1.template2,
    template3: templates_1.template3
};
/**
 * Returns a formatting template based on key passed in
 * Defaults to returning `template1` template
 * @param key
 * @returns
 */
const templateFromKey = (key) => {
    if (exports.formatTemplateMap[key]) {
        return exports.formatTemplateMap[key];
    }
    return exports.formatTemplateMap.template1;
};
exports.templateFromKey = templateFromKey;
//# sourceMappingURL=Template.js.map